<template>
  <v-row>
    <template v-for="(file, idx) in storageFiles">
      <v-col cols="6" xs="6" sm="3">
        <v-hover v-slot:default="{ hover }">
          <v-card>
            <v-row justify="center">
              <v-col cols="12" class="py-0">
                <v-img
                  style="border-radius: 4px"
                  :src="`${file.url}`"
                  aspect-ratio="1"
                  class="grey lighten-2"
                />

                <v-progress-linear
                  :active="file.uploadPercentage > 0 && file.uploadPercentage < 100"
                  :value="file.uploadPercentage"
                  absolute
                  bottom
                />

                <v-overlay
                  style="border-radius: 4px"
                  :opacity="0.7"
                  :absolute="true"
                  :value="hover"
                >

                  <v-btn
                    icon
                    @click="onDelete(file)"
                  >
                    <v-icon>delete</v-icon>
                  </v-btn>
                </v-overlay>
              </v-col>
            </v-row>
          </v-card>
        </v-hover>
      </v-col>
    </template>
  </v-row>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  props: {
    storagePath: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters([ 'getStorageFilesByPath' ]),
    storageFiles() {
      return this.getStorageFilesByPath(this.storagePath)
    }
  },
  mounted() {
    const payload = {
      storagePath: this.storagePath
    }

    this.loadStorageImages(payload)
  },
  methods: {
    ...mapActions([ 'loadStorageImages', 'deleteStorageImage' ]),
    onDelete(file) {
      const { id } = file

      this.deleteStorageImage({ id })
    },
    debug(val) {
      console.log(val)
    }
  }
}
</script>
